/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = timestamp => {
  let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + "-";
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  let h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  let m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return Y + M + D + h + m + s;
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
  let date = new Date();
  date.setDate(date.getDate() + day);
  document.cookie = name + "=" + value + ";expires=" + date;
}

/**
 * 获取cookie
 **/
function getCookie(name) {
  let reg = RegExp(name + "=([^;]+)");
  let arr = document.cookie.match(reg);
  if (arr) {
    return arr[1];
  } else {
    return "";
  }
}
const getHTMLContent = str =>
  str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "");

const tansParams = params => {
  let result = "";
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof value !== "undefined") {
      if (typeof value === "object") {
        for (const key of Object.keys(value)) {
          if (
            value[key] !== null &&
            value[key] !== "" &&
            typeof value[key] !== "undefined"
          ) {
            let params = propName + "[" + key + "]";
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + value + "&";
      }
    }
  }
  return result;
};
/**
 * 删除cookie
 **/
function delCookie(name) {
  setCookie(name, null, -1);
}
// const baseUrl = 'https://teach.airohit.cn/admin-api'
// const baseUrl = "https://agro.airoteach.cn/education-admin-api/";

// 验证是否为blob格式
function blobValidate(data) {
  return data.type !== "application/json";
}

function getMinTime(t1, t2) {
  if (!t1) return t2;
  if (!t2) return t1;
  return new Date(t1).getTime() <= new Date(t2).getTime() ? t1 : t2;
}
function getMaxTime(t1, t2) {
  if (!t1) return t2;
  if (!t2) return t1;
  return new Date(t1).getTime() >= new Date(t2).getTime() ? t1 : t2;
}
/**
 * 导出
 **/
export {
  timestampToTime,
  setStore,
  getStore,
  removeStore,
  setCookie,
  getCookie,
  delCookie,
  // baseUrl,
  tansParams,
  getHTMLContent,
  blobValidate,
  getMinTime,
  getMaxTime
};



// WEBPACK FOOTER //
// ./src/utils/util.js